export default __webpack_public_path__ + "static/media/I5.7f5bd91b.png";